<template>



  
 


  <v-row justify="center">

     <CategoriaDialog2 ref="componenteEnPadre" @actualizado="despuesDeActualizarPadreProducto"></CategoriaDialog2>


<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>





    <v-dialog v-model="dialogeditarproducto" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          Editar Producto
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
             
<!-- inicio campos -->
 <v-col cols="12" md="12">
<ProductoImg :productoData="producto" @productoEditImg="recibirProductoImg"></ProductoImg>
</v-col>

 <!-- Descripción -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.descripcion"
            label="Descripción"
            :rules="textRules"
            required
          ></v-text-field>
        </v-col>





  <!-- Subcampos -->
  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub1"
      label="Sub 1"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub2"
      label="Sub 2"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub3"
      label="Sub 3"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub4"
      label="Sub 4"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <v-col cols="12" md="6">
    <v-text-field
      v-model="producto.sub5"
      label="Sub 5"
      outlined
      dense
    ></v-text-field>
  </v-col>

  <!-- Info (texto largo) -->
  <v-col cols="12">
    <v-textarea
      v-model="producto.info"
      label="Información detallada"
      auto-grow
      outlined
      rows="6"
      counter="1048576"
      hint="Máximo 1MB de texto (~1 millón de caracteres)"
      persistent-hint
    ></v-textarea>
  </v-col>





        <!-- Estado (radio) -->
        <v-col cols="12" md="6">
          <v-radio-group v-model="producto.estado" row>
            <v-radio label="Activo" value="activo"></v-radio>
            <v-radio label="Inactivo" value="inactivo"></v-radio>
          </v-radio-group>
        </v-col>

        <!-- Modelo -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.modelo"
            label="Modelo"
          ></v-text-field>
        </v-col>

        <!-- Última compra (string por ahora) -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.ultima_compra"
            label="Última compra"
          ></v-text-field>
        </v-col>

        <!-- Código barra -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.codigo_barra"
            label="Código de barra"
          ></v-text-field>
        </v-col>

        <!-- Cantidad total -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.cantidad_total"
            label="Cantidad total"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Utilidad -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.utilidad"
            label="Utilidad"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Utilidad2 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.utilidad2"
            label="Utilidad 2"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Utilidad3 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.utilidad3"
            label="Utilidad 3"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- PCU -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pcu"
            label="Precio de Costo"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" class="d-flex align-center">
          <v-btn outlined small color="orange darken-2" @click="calcularPvu">
            <v-icon left small>mdi-calculator</v-icon>
            Calcular precio de venta (+30%)
          </v-btn>
        </v-col>

        <!-- PVU -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pvu"
            label="PVU"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- PVU2 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pvu2"
            label="PVU2"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- PVU3 -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.pvu3"
            label="PVU3"
            type="number"
          ></v-text-field>
        </v-col>

        <!-- Observaciones -->
        <v-col cols="12">
          <v-text-field
            v-model="producto.obs"
            label="Observaciones"
          ></v-text-field>
        </v-col>

        <!-- Link photo -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.link_photo"
            label="Link foto"
            disabled
           
          ></v-text-field>
        </v-col>

        <!-- Icon -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.icon"
            label="Icon"
             disabled
             v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Zoom -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.zoom"
            label="Zoom"
            type="number"
             disabled
             v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Fotox -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.fotox"
            label="Foto X"
            type="number"
             disabled
             v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Fotoy -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.fotoy"
            label="Foto Y"
            type="number"
             disabled
             v-if="false"
          ></v-text-field>
        </v-col>

        <!-- Producto_id (disabled)
        <v-col cols="12" md="6">
          <v-text-field
            v-model="producto.proveedor.nombre"
            label="Producto"
            type="text"
            disabled
          ></v-text-field>
        </v-col> -->

        <!-- Categoria_id (disabled) -->
        <v-col cols="12" md="6">
          <v-text-field
            :value="producto.categoria ? producto.categoria.descripcion : ''"
            label="Categoría"
            type="text"
            disabled
          ></v-text-field>
        </v-col>
<v-btn color="primary" @click="openCategoriaDialog()">Seleccionar Categoria Ind</v-btn>



<!-- es necesario pasar el objeto producto para agregar su imagen -->


 <!-- <PrincipalEditDialog   :principalData="principal"   @principalEdit="recibirPrincipal"></PrincipalEditDialog> -->
<!-- fin campos -->



            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn     color="error" @click="closeDialog">Cancelar</v-btn>
          <v-btn   color="success" @click="guardarCambios">Registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import productoService from "@/services/tienda/productoService.js";

import CategoriaDialog2 from "@/components/tienda/categoria/CategoriaDialog2.vue";


import ProductoImg from "@/components/tienda/producto/ProductoImg.vue";

  import { 
   
  } from 'vuex'
export default {
  name: 'EditarProductoDialog', // importante para el warning
   components: {CategoriaDialog2 , ProductoImg},

  data() {
    return {

        mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 5000,
      },
      dialogeditarproducto: false,
      producto: {
        descripcion: "",
        estado: "",
        modelo: "",
        ultima_compra: "",
        codigo_barra: "",
        cantidad_total: 0,
        utilidad: 0,
        utilidad2: 0,
        utilidad3: 0,
        pcu: 0,
        pvu: 0,
        pvu2: 0,
        pvu3: 0,
        obs: "",
        link_photo: "",
        icon: "",
        zoom: 0,
        fotox: 0,
        fotoy: 0,
       // proveedor: {nombre:""},
        categoria: { descripcion: '' },
      },

      rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres'
                },
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido"
              //,
            //  (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
    }
  },
  methods: {

    
     recibirProductoImg:function(img){

      console.log('En elemento padre Producto despues de elegir la imagen de producto');
        console.log(img);
    },

    despuesDeActualizarPadreProducto(cat){

  console.log("Ingrese elemento padre de categoria que es Producto");
  console.log(cat);

  this.producto.categoria=cat;

},

    calcularPvu() {
      const costo = parseFloat(this.producto.pcu) || 0;
      this.producto.pvu = Math.round(costo * 1.30);
    },

    openCategoriaDialog() {
 // this.categoriaSeleccionado = { ...categoria }

  
      this.$refs.componenteEnPadre.openDialog();
   

},
    /**
     * Abre el diálogo y carga datos del producto
     */
    openDialog(producto) {
      // clonar para no modificar directo el objeto padre
      //this.producto = { ...producto } //solo es necesario una vez
      this.producto = producto ;
      this.dialogeditarproducto = true
    },
    /**
     * Cierra el diálogo
     */
    closeDialog() {
      this.dialogeditarproducto = false
    },
    /**
     * Guarda los cambios en el servidor
     */
    guardarCambios() {
      productoService.update(this.producto)
        .then(respuesta => {
          // avisar al padre que actualice su lista
          this.$emit('actualizado')
          this.closeDialog()
        }).catch((errors) =>{

          let mensajeError = 'Ha ocurrido un error:\n';

  // Recorremos el array de errores del backend
  if (errors.response && errors.response.data && errors.response.data.errors) {
    errors.response.data.errors.forEach((err, index) => {
      mensajeError += `${index + 1}. ${err}\n`;
    });
  } else {
    mensajeError += 'Error desconocido';
  }

  // Asignamos al snackbar
  this.mensaje.text = mensajeError;
  this.mensaje.snackbar = true; // debe ser boolean
  this.mensaje.color = "error"; // fondo rojo
  this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


  })
        
    }
  }
}
</script>
